export default __webpack_public_path__ + "static/media/incoming_message.38139594.wav";